import is_true from "./is_true";

function getLeadStatus(status) {
    if(is_true(status)) return "Lead";
    else return "Kunde"
}

export default getLeadStatus;